import actionCreatorFactory from 'common/modules/utils/actionCreatorFactory'
import {
    ARBITER_TAG, LAUNCHER_TAG, HEADER_TAG, MENU_TAG, PROMPT_TAG,
    APP_ERROR_TAG,
} from 'common/tags'

const types = {
    INTERNAL_LISTEN: 'INTERNAL/INTERNAL_LISTEN',
    INTERNAL_SEND_MESSAGE: 'INTERNAL/SEND_MESSAGE',
    INTERNAL_RECEIVED_MESSAGE: 'INTERNAL/RECEIVED_MESSAGE',
    INTERNAL_CLOSE: 'INTERNAL/CLOSE',
}

const creators = {
    listen: actionCreatorFactory(types.INTERNAL_LISTEN),
    sendMessage: actionCreatorFactory(types.INTERNAL_SEND_MESSAGE),
    receivedMessage: actionCreatorFactory(types.INTERNAL_RECEIVED_MESSAGE),
    close: actionCreatorFactory(types.INTERNAL_CLOSE),
    showMenu: () => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'FRAME/SHOW_CHILD', frame: MENU_TAG } }),
    showPrompt: ({ popupId }) => ({
        type: types.INTERNAL_SEND_MESSAGE,
        payload: {
            target: ARBITER_TAG,
            type: 'FRAME/SHOW_CHILD',
            frame: PROMPT_TAG,
            popupId,
        },
    }),
    showHeader: () => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'FRAME/SHOW_CHILD', frame: HEADER_TAG } }),
    showLauncher: () => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'FRAME/SHOW_CHILD', frame: LAUNCHER_TAG } }),
    destroyLauncher: () => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'FRAME/HIDE_CHILD', frame: LAUNCHER_TAG } }),
    destroyHeader: () => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'FRAME/HIDE_CHILD', frame: HEADER_TAG } }),
    destroyMenu: () => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'FRAME/HIDE_CHILD', frame: MENU_TAG } }),
    destroyPrompt: () => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'FRAME/HIDE_CHILD', frame: PROMPT_TAG } }),
    destroyAppError: () => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'FRAME/HIDE_CHILD', frame: APP_ERROR_TAG } }),
    toggleButton: () => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'FRAME/TOGGLE_CHILD', frame: LAUNCHER_TAG } }),
    toggleHeader: () => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'FRAME/TOGGLE_CHILD', frame: HEADER_TAG } }),
    toggleMenu: () => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'FRAME/TOGGLE_CHILD', frame: MENU_TAG } }),
    togglePrompt: () => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'FRAME/TOGGLE_CHILD', frame: PROMPT_TAG } }),
    networkRequest: ({ payload }) => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'NETWORK/REQUEST', data: payload } }),
    logout: () => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'AUTH/LOGOUT' } }),
    closePico: () => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'CLOSE_PICO' } }),
    loaderInvalidationEvent: ({ payload = {} } = {}) => ({ type: types.INTERNAL_SEND_MESSAGE, payload: { target: ARBITER_TAG, type: 'LOADER/INVALIDATION_EVENT', ...payload } }),
}

export {
    types,
    creators,
}
